import { render, staticRenderFns } from "./foodInfo.vue?vue&type=template&id=262eed9c&scoped=true&"
import script from "./foodInfo.vue?vue&type=script&lang=js&"
export * from "./foodInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262eed9c",
  null
  
)

export default component.exports